import React from 'react';
import './index.css';
import PostAddIcon from '@mui/icons-material/PostAdd';
import RSSIcon from '@mui/icons-material/RssFeed';
import PrintIcon from '@mui/icons-material/Pages';
import NoEncryption from '@mui/icons-material/NoEncryption';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import { Link } from 'react-router-dom';
import { useStateStore } from '../../services/State';

export default function HomePage() {
    const [user] = useStateStore('userProfile');

    return (
        <section id="homePage" className="col-md-6 col-md-offset-3">
            <header>
                <h2>Welcome, {user.name?.fullName}!</h2>
            </header>
            <main>
                <Link to={`/press-release-editor`}>
                    <PostAddIcon color="primary" />
                    Press Release Editor
                </Link>
                <Link to={`/podcast-editor`}>
                    <RSSIcon style={{color: 'orange'}} />
                    Podcast Editor
                </Link>
                <Link to={`/publication-editor`}>
                    <PrintIcon style={{color: 'purple'}} />
                    Publication Editor
                </Link>
                <Link to={`/calendar-editor`}>
                    <CalendarIcon style={{color: 'green'}} />
                    Calendar Editor
                </Link>
                {user.modules.indexOf('LIBRARY_FULL') !== -1 && 
                    <React.Fragment>
                        <Link to="/permissions" style={{color: 'green'}}>
                            <NoEncryption/>
                            Permissions
                        </Link>
                    </React.Fragment>
                }
                
            </main>
            <footer>
                
            </footer>
        </section>
    );
}